import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { backendTech } from "./technologies.data";

export default function TechBackend() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="Backend"
        highlight="Technologies"
        subtitle="Robust, secure, and scalable backend systems that power your product."
      />

      <TechStackGrid items={backendTech} />
    </section>
  );
}
